module.exports = __webpack_public_path__ + "img/1870-15th Amendment.5dd1c779.jpg";